import { KineticLines, Reveal } from "@/components/Reveal";

/* Shared inner-page hero: eyebrow, oversized kinetic headline, optional copy + image. */
export default function PageHeader({ eyebrow, title, copy, img, dark = false }) {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section className={`relative overflow-hidden ${dark ? "bg-deep text-cream" : "bg-cream text-deep"}`}>
      <div className="mx-auto max-w-[1440px] px-5 pb-14 pt-28 md:px-10 md:pb-20 md:pt-40">
        {eyebrow && (
          <Reveal>
            <p className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-orange-rific" : "text-orange-rific"}`}>
              {eyebrow}
            </p>
          </Reveal>
        )}
        <KineticLines
          mode="view"
          lines={lines}
          className="mt-4 font-display text-[clamp(2.25rem,5vw,3.25rem)] font-extrabold leading-[1.05] tracking-[-0.01em]"
          lineClassName={dark ? "text-cream" : "text-deep"}
        />
        {copy && (
          <Reveal delay={0.2}>
            <p className={`mt-6 max-w-2xl font-body text-base leading-relaxed md:text-lg ${dark ? "text-cream/75" : "text-deep/70"}`}>
              {copy}
            </p>
          </Reveal>
        )}
        {img && (
          <Reveal delay={0.15} className="mt-10 md:mt-14">
            <div className="overflow-hidden rounded-3xl bg-cream">
              <img src={img} alt="" loading="lazy" className="h-auto w-full object-contain" />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
